/**
 * 판정 4분류 표시 SSoT — 라벨·StatusTag tone·표시 순서·기본 노출 분류·부족 필드 라벨.
 * 배지·요약 칩·피드백 선택지·캘린더 등 모든 판정 표기가 여기서 가져와야 같은 판정이 어디서나 같은 색으로 읽힌다.
 *
 * 예비·확인 필요는 "오류·경고"가 아니라 지도사 확인 대상이다 — danger 를 쓰지 않는다(설계원칙: 판정은 보조 수단).
 * 색 매핑은 워크스페이스(Vue) 원본의 판정 색 SSoT(해당=processing 블루 · 예비=purple · 확인 필요=warning · 미해당=default)를 따른다.
 */
import type { StatusTone } from '@/components/common/StatusTag';
import type { ProgramJudgement } from '@/types/judgement';

export const JUDGEMENT_LABEL: Record<ProgramJudgement, string> = {
  MATCHED: '해당',
  PROVISIONAL: '예비',
  NEEDS_CHECK: '확인 필요',
  NOT_MATCHED: '미해당',
};

export const JUDGEMENT_TONE: Record<ProgramJudgement, StatusTone> = {
  /** 해당 — 하이라이트 면(accent) */
  MATCHED: 'info',
  /** 예비 — primary 테두리(해당과 형태로 구분되되 오류로 읽히지 않게) */
  PROVISIONAL: 'primary',
  /** 확인 필요 — 주의 연배지(경고 아이콘 없음) */
  NEEDS_CHECK: 'warning',
  /** 미해당 — 무채색 */
  NOT_MATCHED: 'neutral',
};

const VIEW_TONES: readonly StatusTone[] = ['neutral', 'info', 'primary', 'success', 'warning'];

/** 서버 표현의 톤(디자인 토큰 어휘, specs/068) → 배지 tone. 모르는 값은 무채색 — 오류색으로 떨어지지 않게. */
export function toViewTone(tone: string): StatusTone {
  return (VIEW_TONES as readonly string[]).includes(tone) ? (tone as StatusTone) : 'neutral';
}

/** 표시 순서(요약 바·피드백 선택지 공용). */
export const JUDGEMENT_ORDER: readonly ProgramJudgement[] = [
  'MATCHED',
  'PROVISIONAL',
  'NEEDS_CHECK',
  'NOT_MATCHED',
];

/** 기본 노출 분류 — 미해당 제외(specs/024 FR-025a). 화면 이탈 시 이 값으로 복귀. */
export const DEFAULT_JUDGEMENTS: readonly ProgramJudgement[] = [
  'MATCHED',
  'PROVISIONAL',
  'NEEDS_CHECK',
];

/** 확인 필요를 유발하는 업체 필드 → 한글 라벨(배너·판정 근거 표시). */
export const MISSING_FIELD_LABEL: Record<string, string> = {
  regionSido: '광역 시·도',
  regionSigungu: '시군구',
  openedDate: '개업일',
  repBirthYear: '대표자 출생연도',
  repGender: '대표자 성별',
  employeeCount: '상시 근로자 수',
  industrySection: '업종',
  annualRevenue: '연매출액',
};
